import React from 'react';
import times from 'lodash/times';
import { AccordionLoading } from '../../../../../CommonComponents/OPL/Accordion/Accordion/Accordion.loading';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';

export const ModelGroupsLoading = () => {
  return (
    <Box mt="24" maxWidth={800}>
      {times(4).map(key => (
        <AccordionLoading key={key} mb="16" />
      ))}
    </Box>
  );
};
